import { AbstractEntity } from '@app/shared/model/entity/base/abstractEntity.model';

export class Permission extends AbstractEntity {

    code: string;
    description: string;
    levelAvailable: boolean;

    constructor(code: string) {
        super();
        this.code = code;
    }

}
